import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule,  HttpClientXsrfModule,  HttpEvent,  HttpHandler,  HttpHeaders,  HttpInterceptor,  HttpRequest,  HttpXsrfTokenExtractor,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ThemeModule } from './@theme/@theme.module';
import { GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { ToastrModule } from 'ngx-toastr';
import { JwtInterceptor } from './@theme/service/Interceptor/refresTokenInter';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { MatSliderModule } from '@angular/material/slider';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPrintModule } from 'ngx-print';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { BnNgIdleService } from 'bn-ng-idle';
import { QRCodeModule } from 'angular2-qrcode';
import { BypassSecurityComponent } from './bypass-security.component';
import { InnerHtmlBindingComponent } from './inner-html-binding.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonsModule } from '@progress/kendo-angular-buttons';




// export function HttpLoaderFactory(httpClient: HttpClient) {
//   return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
// }

// @Injectable()
// export class XhrInterceptor implements HttpInterceptor {
//   constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     const cookieheaderName = 'X-XSRF-TOKEN';
//     let csrfToken = this.tokenExtractor.getToken() as string;
//     console.log(`this.tokenExtractor`, this.tokenExtractor);
//     if (csrfToken !== null && !req.headers.has(cookieheaderName)) {
//     req = req.clone({ headers: req.headers.set(cookieheaderName, csrfToken) });
//     }
//     return next.handle(req);
//     }
// }

@NgModule({
  declarations: [
    AppComponent,
    BypassSecurityComponent,
    InnerHtmlBindingComponent,
    // SafePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ThemeModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    FormsModule,
    HttpClientModule,
    // HttpClientXsrfModule.withOptions({
    //   cookieName: 'XSRF-TOKEN',
    //   headerName: 'XSRF-TOKEN',
    //   }),
    // HttpClientXsrfModule.withOptions({cookieName: 'XSRF-TOKEN'}),
    BrowserAnimationsModule,
    NoopAnimationsModule,
    GridModule,
    PDFModule,
    ToastrModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    TooltipModule,
    MatSliderModule,
    MatSliderModule,
    NgxPrintModule,
    ChartsModule,
    ExcelExportModule,
    QRCodeModule,
    DateInputsModule,
    LabelModule,
    ButtonsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ NgxPrintModule, 
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    Location, { provide: LocationStrategy, useClass: HashLocationStrategy },
    // { provide: HTTP_INTERCEPTORS, useClass: XhrInterceptor, multi: true },
    BnNgIdleService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private tokenExtractor: HttpXsrfTokenExtractor){}
 }
